<template>
  <div style="width: 100%;">
    <v-row>
      <v-col cols="8">
        <v-container>
          <v-row>
            <v-col class="d-flex flex-row align-center">
              <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h1>{{this.plural}}</h1>
              <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="loader"
                  style="margin-left: 10px;"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                  :headers="headers"
                  :items="allData"
                  :items-per-page="1000000"
                  class="elevation-1"
                  @click:row="rowClick"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="4">
        <v-container>
          <v-row>
            <v-col class='d-flex flex-row align-center'>
              <h1>New {{this.singular}}<span v-if="this.data.name">:</span> {{this.data.name}}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                  label="Name"
                  outlined
                  v-model="data.name"
              />
              <v-text-field
                  label="Short Name"
                  outlined
                  v-model="data.metadata.shortName"
              />
              <v-text-field
                  label="Description"
                  outlined
                  v-model="data.metadata.description"
              />
              <v-text-field
                  label="Icon"
                  outlined
                  v-model="data.metadata.icon"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn @click="create" :disabled="!this.data.name">Create</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: 'ID', value: 'id' },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Short Name', value: 'metadata.shortName' },
          { text: 'Description', value: 'metadata.description' },
          { text: 'Icon', value: 'metadata.icon' }
        ],
        editMode: false,
        allData: [],
        data: {
          metadata: {}
        },
        singular: "Location",
        singularLower: "location",
        plural: "Locations",
        pluralLower: "locations"
      }
    },
    async mounted(){
        await this.getAllData();
    },
    computed: {
      ...mapGetters(['getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      async getAllData(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
          this.allData = res.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.data)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
            this.data={
              metadata: {}
            };
            await this.getAllData();
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }
    }
  }
</script>
